import { render, staticRenderFns } from "./EditCamera.vue?vue&type=template&id=56578f47&scoped=true"
import script from "./EditCamera.vue?vue&type=script&lang=js"
export * from "./EditCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56578f47",
  null
  
)

export default component.exports